import { render, staticRenderFns } from "./WeatherWarning.vue?vue&type=template&id=fecffdd2&scoped=true"
import script from "./WeatherWarning.vue?vue&type=script&lang=js"
export * from "./WeatherWarning.vue?vue&type=script&lang=js"
import style0 from "./WeatherWarning.vue?vue&type=style&index=0&id=fecffdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecffdd2",
  null
  
)

export default component.exports